import React, { useEffect, useState } from 'react'
import { Modal, Button } from 'react-bootstrap';

import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import * as locales from 'react-date-range/dist/locale';
import { addDays } from 'date-fns'

export default function FilterPeriodo({ show, callback, reload, dataSet, periodo }) {
    const [state, setState] = useState([{
        startDate: new Date(),
        endDate: addDays(new Date(), 30),
        key: 'selection'
    }]);

    useEffect(() => {
        periodo(state)
    }, [state])

    useEffect(() => {
        if (show)
            setState([{
                startDate: new Date(),
                endDate: addDays(new Date(),30),
                key: 'selection'
            }])
    }, [show])

    return (
        <Modal show={show} size="md" aria-labelledby="contained-modal-title-vcenter" centered onHide={() => callback(false)} dialogClassName="box-periodo">
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <i className="fa fa-calendar" /> Período
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ justifyContent: "center", display: "flex", padding: "15px" }}>
                <DateRange
                    editableDateInputs={true}
                    onChange={item => setState([item.selection])}
                    moveRangeOnFirstSelection={false}
                    locale={locales['ptBR']}
                    ranges={state} />

            </Modal.Body>
            <Modal.Footer style={{ padding: "3px", justifyContent: 'flex-end' }}>
                <Button type="submit" variant="success" style={{ width: "95px" }} onClick={e => { callback(false)
                                                                                                 reload(true) }}><i className="fa fa-save" /> Filtrar</Button>
                <Button style={{ width: "95px", marginRight: "12px" }} onClick={e => { periodo(null); callback(false) }}><i className="fa fa-window-close" /> Sair</Button>
            </Modal.Footer>
        </Modal>
    )
}